module.exports = __webpack_public_path__ + "static/media/introducaoLogicaPython.22f104ce.png";